const FooterActions = ({ showQr, setShowQr, handleCloseWelcomeModal, theme }) => (
    <div className="card-footer d-flex p-0">
        <button 
            className={`btn btn-outline-${theme.main} w-50 m-0 rounded-0 btn-sm`} 
            onClick={() => setShowQr(!showQr)}
        >
            {showQr ? "Go to welcome screen" : "Start compliance in app"}
        </button>
        <button 
            className={`btn btn-${theme.main} w-50 m-0 rounded-0 btn-sm`} 
            onClick={handleCloseWelcomeModal}
        >
            Start compliance in web
        </button>
    </div>
);

export default FooterActions;